import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-admin-setting-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
})
export class AppAdminSettingHeaderComponent {


    @Input() tableColumns: any;
    @Input() itemLanguage: any;
    @Input() sortIsActivated: any;
    @Input() sortedColumn: any;
    @Input() order: any;

    @Output() sortAction = new EventEmitter<any>();

    sort(column) {
        let field = column['0'];

        if (column[3] === 'name') {
            field = field + this.itemLanguage;
        }

        this.sortAction.emit(field);
    }
}
